import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ChatBot } from "@/components/ChatBot";
import { ScrollToTop } from "@/components/ScrollToTop";
import { LocalBusinessSchema } from "@/components/SEO";
import { ServiceAreaMap } from "@/components/GoogleMap";
import { BUSINESS } from "@/data/businessInfo";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ServiceAreasPage from "@/pages/ServiceAreasPage";
import LocationPage from "@/pages/LocationPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import ReviewsPage from "@/pages/ReviewsPage";
import BlogPage from "@/pages/BlogPage";
import BookingPage from "@/pages/BookingPage";
import GalleryPage from "@/pages/GalleryPage";
import AdminPage from "@/pages/AdminPage";
import BlogPostPage from "@/pages/BlogPostPage";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <LocalBusinessSchema />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/service-areas/:id" element={<LocationPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        {/* Meet the Owner - site-wide above footer */}
        <section className="bg-[#FAFAFA] py-14 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <img src={BUSINESS.images.owner} alt="Anthony Mazza, owner of Southern Light Solutions LLC" className="w-full h-auto max-w-md mx-auto rounded-2xl shadow-xl border border-[#6B3A1F]/10" loading="lazy" />
              </div>
              <div>
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D97904] mb-3 block" style={{ fontFamily: 'Outfit, sans-serif' }}>Meet the Owner</span>
                <h2 className="text-2xl sm:text-3xl font-bold text-[#401303] tracking-tight leading-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Anthony Mazza</h2>
                <p className="text-[#6B3A1F] leading-relaxed mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>With over 15 years of hands-on experience, Anthony is the Treasure Coast electrician who shows up on time, gives you a straight answer, and does the work right the first time. His passion for hard work and dedication to the community is what sets Southern Light Solutions apart.</p>
                <p className="text-sm text-[#6B3A1F]/80 mb-5" style={{ fontFamily: 'Manrope, sans-serif' }}>Licensed Electrical Contractor EC13007447 &middot; BBB A-Rated &middot; 5.0 on Google</p>
                <div className="flex flex-wrap gap-3">
                  <a href={`tel:${BUSINESS.phoneRaw}`} className="inline-flex items-center gap-2 px-6 py-3 btn-gradient rounded-full text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    <Phone className="w-4 h-4" /> Call Anthony
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Map */}
        <section className="bg-[#FAFAFA] py-0">
          <ServiceAreaMap className="h-[300px] lg:h-[350px] rounded-none" />
        </section>
        <Footer />
        <ChatBot />
        <Toaster position="bottom-left" richColors />
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
